const PLATFORM_INFORMATIONS = {
  LINKEDIN: "linkedin",
  TWITTER: "twitter",
  DRIBBLE: "dribble",
  STACKOVERFLOW: "stackoverflow",
  GITHUB: "github",
};

export { PLATFORM_INFORMATIONS };
